import myTheme, { Styles } from "../../../../../../slides/theme";
import knifePath from "../../../../../../slides/assets/knife.svg";
import sitemapPath from "../../../../../../slides/assets/sitemap.svg";
import chatPath from "../../../../../../slides/assets/chat.svg";
import rocketPath from "../../../../../../slides/assets/rocket.svg";
import lockPath from "../../../../../../slides/assets/lock.svg";
import clockPath from "../../../../../../slides/assets/clock.svg";
import magicPath from "../../../../../../slides/assets/magic.svg";
import finishPath from "../../../../../../slides/assets/finish.svg";
import packageJsonPath from "../../../../../../slides/assets/code/toolkit-package-json.png";
import examplePath from "../../../../../../slides/assets/code/example.png";
import bundleSquarePath from "../../../../../../slides/assets/code/example-01-square.png";
import bundleRandomPath from "../../../../../../slides/assets/code/example-01-random.png";
import bundleMainPath from "../../../../../../slides/assets/code/example-01-main.png";
import compileSquarePath from "../../../../../../slides/assets/code/example-02-square.png";
import compileRandomPath from "../../../../../../slides/assets/code/example-02-random.png";
import compileMainPath from "../../../../../../slides/assets/code/example-02-main.png";
import testSquarePath from "../../../../../../slides/assets/code/example-03-square.png";
import testMainPath from "../../../../../../slides/assets/code/example-03-main.png";
import webpackConfigPath from "../../../../../../slides/assets/code/webpack-config.png";
import babelConfigPath from "../../../../../../slides/assets/code/babel-config.png";
import jestConfigPath from "../../../../../../slides/assets/code/jest-config.png";
import jestSetupPath from "../../../../../../slides/assets/code/jest-setup.png";
import bootstrappingPath from "../../../../../../slides/assets/code/bootstrapping.png";
import Container from "../../../../../../slides/components/Container";
import Heading from "../../../../../../slides/components/Heading";
import Text from "../../../../../../slides/components/Text";
import Small from "../../../../../../slides/components/Small";
import React from 'react';
export default {
  myTheme: myTheme,
  Styles: Styles,
  knifePath: knifePath,
  sitemapPath: sitemapPath,
  chatPath: chatPath,
  rocketPath: rocketPath,
  lockPath: lockPath,
  clockPath: clockPath,
  magicPath: magicPath,
  finishPath: finishPath,
  packageJsonPath: packageJsonPath,
  examplePath: examplePath,
  bundleSquarePath: bundleSquarePath,
  bundleRandomPath: bundleRandomPath,
  bundleMainPath: bundleMainPath,
  compileSquarePath: compileSquarePath,
  compileRandomPath: compileRandomPath,
  compileMainPath: compileMainPath,
  testSquarePath: testSquarePath,
  testMainPath: testMainPath,
  webpackConfigPath: webpackConfigPath,
  babelConfigPath: babelConfigPath,
  jestConfigPath: jestConfigPath,
  jestSetupPath: jestSetupPath,
  bootstrappingPath: bootstrappingPath,
  Container: Container,
  Heading: Heading,
  Text: Text,
  Small: Small,
  React: React
};